import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { GameState, GameAction } from '../types/game.ts';

const initialState: GameState = {
  roomId: '',
  players: [],
  currentPlayer: null,
  board: [],
  scores: {},
  gameStatus: 'waiting',
  error: null,
  winner: null
};

const GameContext = createContext<{
  state: GameState;
  dispatch: React.Dispatch<GameAction>;
} | undefined>(undefined);

const gameReducer = (state: GameState, action: GameAction): GameState => {
  switch (action.type) {
    case 'SET_ROOM':
      return { ...state, roomId: action.payload };
    case 'SET_PLAYERS':
      return { ...state, players: action.payload };
    case 'SET_CURRENT_PLAYER':
      return { ...state, currentPlayer: action.payload };
    case 'SET_BOARD':
      return { ...state, board: action.payload };
    case 'UPDATE_SCORE':
      return {
        ...state,
        scores: { ...state.scores, [action.payload.playerId]: action.payload.score }
      };
    case 'SET_SCORES':
      return { ...state, scores: action.payload };
    case 'SET_GAME_STATUS':
      return { ...state, gameStatus: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    case 'RESET_GAME':
      return initialState;
    default:
      return state;
  }
};

export const GameProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(gameReducer, initialState);

  return (
    <GameContext.Provider value={{ state, dispatch }}>
      {children}
    </GameContext.Provider>
  );
};

export const useGame = () => {
  const context = useContext(GameContext);
  if (context === undefined) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
}; 